import { createApiClient } from '@/service/request'
import { useUserStore } from '@/stores/userStore'
export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_SITE_URL,
  forceFullApiPath: true,
  onError: async (response: Response, errorData: any) => {
    if (response.status === 401) {
      const userStore = useUserStore()
      userStore.logout(false)
    }
  },
})
